import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import Cookies from "js-cookie";
import { login } from "./requests";
import { encryptLocalData, decryptLocalData, refreshPermissions, clearPermissionCache } from '@comps/commonFunctions';
import { resetAllPermissionsCache } from '@utils/helpers';

// Define a name for slice
const sliceName = "auth";

// Define the initial state using that type
const initialState = {
  errors: [],
  otpRequired: false,
  loaderState: false,
  authUser: decryptLocalData('user'),
  permissions: {},
}

const clearClientContext = () => {
  localStorage.clear();
  sessionStorage.clear();
  Cookies.remove("token");
  clearPermissionCache();
  resetAllPermissionsCache();
};

export const signinUser = createAsyncThunk(
  `${sliceName}/signinUser`,
  async (auth, thunkApi) => {
    clearClientContext();
    const res = await login(auth);
    if (res.success === true || res.code === 200) {
      localStorage.setItem('tenant', res.data.user.tenant);
      localStorage.setItem('company_id', res.data.user.company_id);
      localStorage.setItem('timezone', res.data.user.timezone)
      encryptLocalData('user', res.data.user);
      //localStorage.setItem("user", JSON.stringify(res.data.user));
      //localStorage.setItem("token", res.data.access_token);
      encryptLocalData('permissions', res.data.permissions)
      refreshPermissions();
      resetAllPermissionsCache();
      //localStorage.setItem("permissions", JSON.stringify());
      Cookies.set("token", res.data.access_token.replace("Bearer ", ""), {
        expires: auth.remember_me ? 7 : 1,
      }); // Set this to cookies
      setTimeout(() => {
        window.location.reload();
      }, 0);
      return res.data;
    } else if (res.code === 202) {
      let data = [];
      data.code = 202;
      data.msg = res.msg;
      return thunkApi.rejectWithValue(data);
    } else {
      let errors = [];
      errors['email'] = res
      return thunkApi.rejectWithValue(errors);
    }
  }
);
export const authSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    logout: (state, action) => {
      clearClientContext();
      return {
        ...initialState,
        authUser: null,

      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signinUser.pending, (state, action) => {
      clearClientContext();
      return {
        ...initialState,
        otpRequired: state.otpRequired,
      };
    });
    builder.addCase(signinUser.fulfilled, (state, action) => {
      return {
        ...initialState,
        loaderState: true,
        authUser: action.payload.user,
        permissions: action.payload.permissions
      };
    });
    builder.addCase(signinUser.rejected, (state, action) => {
      if (action.payload && action.payload.code && action.payload.code === 202) {
        return {
          ...initialState,
          otpRequired: true,
          errors: action.payload.msg
        };
      }
      return {
        ...initialState,
        otpRequired: state.otpRequired,
        errors: action.payload
      };
    });
  }
});

export default authSlice.reducer;
export const { logout } = authSlice.actions;
